<template>
  <section class="cover unit">
    <svg viewBox="0 0 984 20"><line x1="6" y1="10" x2="984" y2="10" /></svg>

    <p class="cover-lead__catch is-sp-large">カンタンな<strong class="u-strong">心理テスト</strong>で<br><strong class="u-strong">"ぴったり"の講座</strong>が見つかる！</p>
    <img class="cover-main" src="/diagnosis/common/img/cover_main.png" alt="さぁ、今すぐやってみよう！" width="640" height="201">
    <div class="cover-select section-block unit">
      <ul class="cover-select__list">
        <li class="cover-select__item">
          <button class="cover-select__btn cover-select__btn--female" @click="onClickFemaleBtn">女 性</button>
        </li>
        <li class="cover-select__item">
          <button class="cover-select__btn cover-select__btn--male" @click="onClickMaleBtn">男 性</button>
        </li>
      </ul>
    </div>

    <p class="cover-discription section-block is-sp-large">心理学を用いて、６つの特性であなたの性格を診断。診断結果からあなたにピッタリの講座をご紹介します。</p>

    <div class="cover-note u-small-text section-block">
      <dl class="cover-note__list">
      <dt class="cover-note__title">ご利用上の注意</dt>
      <dd class="cover-note__item">診断の性質上、直感でご回答いただいたほうが、より診断結果の精度が上がります。そのため、一度答えた設問には戻ることができませんので、あらかじめご了承ください。</dd>
      <dd class="cover-note__item">ご使用の機種によっては、診断結果画面でブラウザの「戻る」ボタンをタップした際、正常に動作しない場合があります。再度、診断を行う場合は、診断結果画面内の「診断TOPに戻る」ボタンをタップし、診断TOP画面へ戻ってください。</dd>
      </dl>
    </div>
  </section>
</template>


<script>
export default {
  name: 'Cover',

  methods: {
    onClickFemaleBtn: function () {
      this.$emit('click-female-btn', 'f')
    },
    onClickMaleBtn: function () {
      this.$emit('click-male-btn', 'm')
    }
  }
}
</script>


<style scoped>
</style>